export default {
  // NAV
  "nav.overview": "Overview",
  "nav.transport": "Transport Routes",
  "nav.contracts": "Contracts",
  "nav.profitability": "Profitability",
  "nav.market": "Market Analysis",
  "nav.contact": "Contact",
  "nav.investNow": "Invest Now",
  // OVERVIEW
  "overview.badge": "Exclusive Investment Opportunity",
  "overview.line1": "Strait of Hormuz",
  "overview.line2": "Closed. Saudi Arabia",
  "overview.line3": "Controls Everything.",
  "overview.desc": "With the closure of the Strait of Hormuz, <1>Saudi Aramco</1> becomes the sole channel for transporting oil from the Persian Gulf. UAE, Kuwait, Iran — all are forced to use Saudi infrastructure.",
  "overview.subDesc": "This is a historically unique situation. Enter a contract now — while the window is open.",
  "overview.viewContracts": "View Contracts",
  "overview.marketAnalysis": "Market Analysis",
  "overview.stat.barrels": "Barrels / Day",
  "overview.stat.transitShare": "Gulf Transit Share",
  "overview.stat.oilPrice": "Projected Oil Price",
  "overview.stat.nations": "Nations Dependent",
  // TRANSPORT
  "transport.badge": "Infrastructure",
  "transport.title1": "Transport",
  "transport.title2": "Routes",
  "transport.desc": "When the Strait of Hormuz is closed, all oil flows from the Persian Gulf are rerouted through Saudi infrastructure. There is no alternative.",
  "transport.route1.title": "East-West Pipeline (Petroline)",
  "transport.route1.desc": "Main alternative pipeline — 1,200 km from Abqaiq to Yanbu. Capacity 5 million bbl/day. The only bypass route around Hormuz.",
  "transport.route1.status": "Active",
  "transport.route2.title": "Port of Yanbu (Red Sea)",
  "transport.route2.desc": "Main export terminal via the Red Sea. Direct access to the Suez Canal and European markets without passing through the Strait of Hormuz.",
  "transport.route2.status": "Active",
  "transport.route3.title": "Ras Tanura Terminal",
  "transport.route3.desc": "The world's largest oil terminal. When the strait is closed — a transit hub for UAE, Kuwait and Bahrain.",
  "transport.route3.status": "Strategic Hub",
  "transport.route4.title": "Abqaiq Processing Complex",
  "transport.route4.desc": "The world's largest oil processing complex. Processes oil from neighboring countries for transport via Saudi pipelines.",
  "transport.route4.status": "Processing",
  "transport.tableTitle": "Countries Dependent on Saudi Transit",
  "transport.col.country": "Country",
  "transport.col.role": "Role",
  "transport.col.volume": "Daily Volume",
  "transport.role.operator": "Operator",
  "transport.role.transit": "Transit client",
  "transport.role.forced": "Forced transit",
  // CONTRACTS
  "contracts.badge": "Investment Plans",
  "contracts.title1": "Choose Your",
  "contracts.title2": "Contract",
  "contracts.desc": "Three levels of investment contracts with guaranteed returns. Choose your participation level and earn profit from every barrel.",
  "contracts.plan1.name": "Entry Contract",
  "contracts.plan2.name": "Standard Contract",
  "contracts.plan3.name": "Premium Contract",
  "contracts.plan2.badge": "Most Popular",
  "contracts.plan3.badge": "Maximum Return",
  "contracts.subLabel": "Saudi Aramco Transit",
  "contracts.minInvestment": "minimum investment",
  "contracts.profitRate": "Profit Rate",
  "contracts.estReturn": "Est. Return",
  "contracts.totalPayout": "Total Payout",
  "contracts.getStarted": "Get Started →",
  "contracts.plan1.f1": "30% guaranteed profit return",
  "contracts.plan1.f2": "Access to Yanbu terminal routes",
  "contracts.plan1.f3": "Monthly profit disbursement",
  "contracts.plan1.f4": "Dedicated account manager",
  "contracts.plan1.f5": "Quarterly market reports",
  "contracts.plan2.f1": "40% guaranteed profit return",
  "contracts.plan2.f2": "Priority East-West Pipeline access",
  "contracts.plan2.f3": "Bi-weekly profit disbursement",
  "contracts.plan2.f4": "Senior account manager",
  "contracts.plan2.f5": "Weekly market intelligence",
  "contracts.plan2.f6": "Access to secondary contracts",
  "contracts.plan3.f1": "50% guaranteed profit return",
  "contracts.plan3.f2": "Full Aramco network access",
  "contracts.plan3.f3": "Weekly profit disbursement",
  "contracts.plan3.f4": "VIP relationship manager",
  "contracts.plan3.f5": "Real-time market data feed",
  "contracts.plan3.f6": "Priority re-contract option",
  "contracts.plan3.f7": "Private investor briefings",
  "contracts.guaranteeTitle": "Contract Guarantee:",
  "contracts.guaranteeText": "All contracts are backed by real volumes of transit oil through the Saudi Aramco network. Payments are made monthly to the investor\'s account after the transit cycle closes.",
  // PROFITABILITY
  "profitability.badge": "ROI Calculator",
  "profitability.title1": "Your",
  "profitability.title2": "Profitability",
  "profitability.desc": "Calculate your expected income based on the investment amount and selected contract.",
  "profitability.calcTitle": "Investment Calculator",
  "profitability.selectTier": "Select Contract Tier",
  "profitability.customLabel": "Custom Investment Amount ($)",
  "profitability.minNote": "Min: ${{amount}} for this tier",
  "profitability.profitRate": "Profit Rate",
  "profitability.invested": "Invested",
  "profitability.profit": "Profit",
  "profitability.total": "Total",
  "profitability.scenarioTitle": "Scenario Analysis",
  "profitability.conservative": "Conservative",
  "profitability.base": "Base Case",
  "profitability.optimistic": "Optimistic",
  "profitability.whyTitle": "Why Returns Are Guaranteed",
  "profitability.why1": "Oil is already contracted — returns are secured by real deliveries",
  "profitability.why2": "Funds held in escrow at Saudi National Bank until payout",
  "profitability.why3": "Contract regulated by Saudi Petroleum Authority (SPA)",
  "profitability.why4": "Independent PWC audit every quarter",
  // MARKET
  "market.badge": "Data & Intelligence",
  "market.title1": "Market",
  "market.title2": "Analysis",
  "market.desc": "Real data on oil prices, transit volumes and market dynamics under the closed Strait of Hormuz.",
  "market.metric1": "Brent Crude (Current)",
  "market.metric2": "Saudi Aramco Stock",
  "market.metric3": "Gulf Transit Premium",
  "market.metric4": "Hormuz Closure Duration",
  "market.metric4change": "Ongoing",
  "market.chartTitle": "Oil Price: Normal vs. Hormuz Crisis",
  "market.normal": "Normal",
  "market.crisis": "Crisis",
  "market.avgIncrease": "average price increase during crisis",
  "market.newsTitle": "Latest Intelligence",
  "market.tag.breaking": "Breaking",
  "market.tag.deal": "Deal",
  "market.tag.surge": "Price Surge",
  "market.tag.agreement": "Agreement",
  "market.news1": "Strait of Hormuz: 89% of Persian Gulf exports now rerouted via Saudi pipelines",
  "market.news2": "UAE renegotiates 3-year transit deal with Saudi Aramco — $4.2B contract signed",
  "market.news3": "Brent crude hits $142/bbl as Hormuz closure enters 6th week",
  "market.news4": "Kuwait signs emergency transport agreement with Saudi Aramco for 2.8M bbl/day",
  "market.strategic.badge": "Strategic Position",
  "market.strategic.title": "Saudi Arabia controls 100% of alternative oil flows from the Gulf",
  "market.strategic.desc": "With Hormuz closed, other Arab countries are forced to sell oil to the Saudis at reduced prices for onward transport — this multiplies the profitability of every transit contract.",
  // CONTACT
  "contact.badge": "Get In Touch",
  "contact.title1": "Start Your",
  "contact.title2": "Investment",
  "contact.desc": "Fill out the form — our manager will contact you within 24 hours and guide you through all the contract steps.",
  "contact.info1.title": "Headquarters",
  "contact.info1.text": "Saudi Aramco HQ, Dhahran, Eastern Province, Saudi Arabia 31311",
  "contact.info2.title": "Investor Line",
  "contact.info2.text": "+966 13 872 0115 (24/7 Investment Desk)",
  "contact.info3.title": "Email",
  "contact.info3.text": "investors@aramco-transit.com",
  "contact.info4.title": "Response Time",
  "contact.info4.text": "Within 24 hours — guaranteed",
  "contact.hqLabel": "Saudi Aramco — Dhahran HQ",
  "contact.hqSub": "World\'s most valuable energy company",
  "contact.formTitle": "Investment Application",
  "contact.label.name": "Full Name",
  "contact.label.email": "Email",
  "contact.label.phone": "Phone Number",
  "contact.label.contract": "Select Contract",
  "contact.label.message": "Message (optional)",
  "contact.ph.name": "John Smith",
  "contact.ph.email": "john@example.com",
  "contact.ph.phone": "+1 234 567 8900",
  "contact.ph.message": "Questions, investment goals, or additional information...",
  "contact.opt1": "Entry Contract — $3,000 (30% profit)",
  "contact.opt2": "Standard Contract — $5,000 (40% profit)",
  "contact.opt3": "Premium Contract — $10,000 (50% profit)",
  "contact.submit": "Submit Investment Application →",
  "contact.submitting": "Submitting...",
  "contact.disclaimer": "By submitting you agree to our Terms & Conditions. All investments carry risk. Past performance does not guarantee future results.",
  "contact.successTitle": "Application Submitted!",
  "contact.successDesc": "Your application has been received. An investment manager will contact you within 24 hours.",
  "contact.anotherRequest": "Submit another request",
  "contact.error": "Submission failed. Please try again.",
  // FOOTER
  "footer.desc": "Leverage a unique geopolitical situation. Invest in guaranteed oil contracts with Saudi Aramco — the sole operator of oil transit from the Persian Gulf.",
  "footer.navTitle": "Navigation",
  "footer.contractsTitle": "Contracts",
  "footer.readyTitle": "Ready to Invest?",
  "footer.readyDesc": "Open window — act now.",
  "footer.viewContracts": "View Contracts",
  "footer.copyright": "© 2026 Saudi Aramco Investment Portal. All rights reserved.",
  "footer.legalNote": "This is an investment portal. All investments carry risk. This platform does not guarantee returns. Please consult a financial advisor before investing.",
};
